'use strict';
(function () {
  angular.module('pentaApp').factory('flyerViewLog.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/flyerViewLog');
  }
})();